import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import { MdOutlineFeaturedPlayList } from "react-icons/md";
import { MdLaunch } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { GrResources } from "react-icons/gr";
import { MdOutlineIntegrationInstructions } from "react-icons/md";
import { whatsLaunched } from "common/StringUtils";
import ViewLaunchedModal from "./ViewLaunchedModal";
import { LOCALES } from "common/constants";
import axios from "axios";
import "./newlaunched.css";

export const NewLaunched = ({ language, t }) => {
  const [modalState, setModalState] = useState({
    show: false,
    data: {},
  });
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch {
      return null;
    }
  });
  const [freeInvoiceCount, setFreeInvoiceCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFreeInvoiceCount = async () => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("user"));
        if (storedUser?.token) {
          const response = await axios.get('/invoice/get-user-free-invoice-count');
          if (response.data && response.status === 200) {
            setFreeInvoiceCount(response.data);
          }
        }
      } catch (error) {
        console.error("Error fetching free invoice count:", error);
      }
    };

    fetchFreeInvoiceCount();
  }, []);

  useEffect(() => {
    const handleStorage = () => {
      try {
        setUser(JSON.parse(localStorage.getItem("user")));
      } catch {
        setUser(null);
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  // Optionally, update user state if this tab changes localStorage
  useEffect(() => {
    const interval = setInterval(() => {
      try {
        setUser(JSON.parse(localStorage.getItem("user")));
      } catch {
        setUser(null);
      }
    }, 2000); // Poll every 2 seconds
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Container style={{ marginTop: "30px" }}>
      
        <Row>
          <Col md={12} className="mb-4">
            {freeInvoiceCount < 3 && (
          <div className="holiday-offer-banner">
            <div className="holiday-offer-content flex-column flex-md-row">
              <div className="holiday-offer-text">
                <h3 className="holiday-offer-title">
                  🎁
                  {t("CHRISTMAS_OFFER")}: {t("3_FREE_INVOICES")}
                </h3>
                <p className="holiday-offer-subtitle">
                  {t("ALL_NEW_AND_EXISTING_USERS_GET")}
                </p>
              </div>
              <p className="holiday-offer-subtitle">
                {t("YOU_HAVE")} <b> {3 - freeInvoiceCount} </b>{t("FREE_INVOICES_LEFT")}
              </p>
            </div>
          </div>
        )}
        </Col>
        
          <Col md={6} className="mb-4">
            <Card className="h-100 overflow-hidden shadow">
              <Card.Body className="new-launched" style={{ padding: "35px" }}>
                <div className="content">
                  <div className="imge_icns" style={{ marginRight: "15px" }}>
                    <MdOutlineIntegrationInstructions size={30} />
                  </div>
                  <div className="content-group">
                    <h3 className="new_card-design">
                      {t("Things to do before start")}
                    </h3>
                    {/* Show different content based on customerSalaryInformation */}
                    {Array.isArray(user?.userData?.customerSalaryInformation) &&
                    user?.userData?.customerSalaryInformation.length === 0 ? (
                      <Card.Text>
                        <ul>
                          <li>
                            {" "}
                            <a
                              style={{ textDecoration: "underline" }}
                              className="cursor-pointer"
                              onClick={() => {
                                navigate(
                                  language === LOCALES.EN_US
                                    ? `/dashboard/settings/bank-information?lang=${LOCALES.EN_US}`
                                    : `/instrumentbrada/installningar/bankinformation?lang=${LOCALES.SV_SE}`
                                );
                              }}
                            >
                              {t("Verify your bank information")}
                            </a>
                          </li>
                        </ul>
                      </Card.Text>
                    ) : (
                      <Card.Text>
                        <p>{t("All Done")}</p>
                      </Card.Text>
                    )}
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} className="mb-4">
            <Card border="primary" className="overflow-hidden shadow">
              <Card.Body
                className="new-launched"
                style={{ padding: "35px" }}
                // onClick={() => scrollToElement(data?.id)}
              >
                <div className="content">
                  <div className="imge_icns" style={{ marginRight: "15px" }}>
                    <MdLaunch size={30} />
                  </div>
                  <div className="content-group">
                    <h3 className="new_card-design">{t("Upcoming")}</h3>
                    <Card.Text>
                      <h6>
                        <b>{t("New_Web_Pages")}</b>
                      </h6>
                      <h6>
                      <b>{t("New options for articles when creating an invoice")}</b>
                      </h6>
                      <h6>
                        <b>{t("Invoice send type feature")}</b>
                      </h6>
                      <a
                      // onClick={() =>
                      //   setModalState({
                      //     show: true,
                      //     data: {
                      //       title: "New pages for Pension & a health insurance",
                      //       desc: "Now salary details having more details",
                      //     },
                      //   })
                      // }
                      >
                        {/* Now salary details having more details */}
                      </a>
                    </Card.Text>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mb-4">
            <Card border="primary" className="h-100 overflow-hidden shadow">
              <Card.Body
                className="new-launched"
                style={{ padding: "35px" }}
                // onClick={() => scrollToElement(data?.id)}
              >
                <div className="content">
                  <div className="imge_icns" style={{ marginRight: "15px" }}>
                    <GrResources size={30} />
                  </div>
                  <div className="content-group">
                    <h3 className="new_card-design">
                      {t("Help and Resources")}
                    </h3>
                    <Card.Text>
                      <ul>
                        <li className="py-1">
                          <Link
                            to={
                              language === LOCALES.EN_US
                                ? `/faq?lang=${LOCALES.EN_US}`
                                : `/faq?lang=${LOCALES.SV_SE}`
                            }
                            style={{ textDecoration: "underline" }}
                          >
                            {t("See FAQ")}
                          </Link>
                        </li>
                        <li className="py-1">
                          <Link
                            to={
                              language === LOCALES.EN_US
                                ? `/function?lang=${LOCALES.EN_US}`
                                : `/funktion?lang=${LOCALES.SV_SE}`
                            }
                            style={{ textDecoration: "underline" }}
                          >
                            {t("See Our Features")}
                          </Link>
                        </li>
                                <li className="py-1">
                          <a
                            href={
                              language === LOCALES.EN_US
                                ? `https://invozioprod.blob.core.windows.net/files/user%20_manual_invozio__eng_light.pdf?sp=r&st=2025-04-24T11:17:36Z&se=2050-04-24T19:17:36Z&spr=https&sv=2024-11-04&sr=b&sig=qvGePPhQxSOb1KlbPlgwgotnbXXILHhlRh5vudjGXrc%3D`
                                : `https://invozioprod.blob.core.windows.net/files/user%20_manual_invozio__swe_light.pdf?sp=r&st=2025-04-24T11:20:10Z&se=2050-04-24T19:20:10Z&spr=https&sv=2024-11-04&sr=b&sig=Z88XAYoDo%2F8YiFEg7hoBsw8BzUkH%2FaxYkSmY02TJR%2Fc%3D`
                            }
                            style={{ textDecoration: "underline" }}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {t("MANUAL")}
                          </a>
                        </li>
                      </ul>
                    </Card.Text>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} className="mb-4">
            <Card border="primary" className=" overflow-hidden shadow">
              <Card.Body className="new-launched" style={{ padding: "35px" }}>
                <div className="content">
                  <div className="imge_icns" style={{ marginRight: "15px" }}>
                    <MdOutlineFeaturedPlayList size={30} />
                  </div>
                  <div className="content-group">
                    <h3 className="new_card-design">{t("What's launched")}</h3>
                    <Card.Text>
                      <ul>
                        {whatsLaunched?.map((item) => (
                          <li key={item?.id} className="my-2 ">
                            {" "}
                            <a
                              style={{ textDecoration: "underline" }}
                              className="cursor-pointer"
                              onClick={() =>
                                setModalState({
                                  show: true,
                                  data: item,
                                })
                              }
                            >
                              {t(item?.title)}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </Card.Text>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      {modalState?.show && (
        <ViewLaunchedModal
          t={t}
          modalState={modalState}
          setModalState={setModalState}
        />
      )}
    </>
  );
};
